import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { ReadClient } from "@/types/client";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect, { Option, type AsyncSelectBaseProps } from "./AsyncSelect";
import { useCreateDataTableOptions } from "./data-table/hooks/useCreateDataTableOptions";
import { StoreStatusService } from "@/modules/store/service/storeStatus";
import appConfiguration from "./cfg/AppCfg";

interface StoreStatusSelectProps extends AsyncSelectBaseProps {
  className?: string;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, StoreStatusSelectProps>(
  function StoreStatusSelect({ value, defaultItem, ...props }, ref) {
    const { t } = useTranslation();
    const options = useCreateDataTableOptions("storeStatusList");
    const queryKey = useDynamicQueryParams<ReadClient>(
      "storeStatusList",
      options,
    );

    return (
      <span className="flex items-center gap-1">
        <AsyncSelect
          queryKey={queryKey}
          queryFn={() =>
            StoreStatusService.getList({
              limit: appConfiguration.selectComponentsPaginationLimit,
            })
          }
          placeholder={t("storeStatusSelect.placeholder")}
          loadingLabel={t("storeStatusSelect.loading")}
          noResultsLabel={t("storeStatusSelect.noResults")}
          searchLabel={t("storeStatusSelect.search")}
          renderName={(option) => t(`storeStatuses.${option.name}`)}
          enableFilter={false}
          {...props}
          value={value ? value.toString() : undefined}
          ref={ref}
          defaultItem={defaultItem}
        />
      </span>
    );
  },
);
